import { ModelDocument } from "@pjs/storage";
import { Observable, startWith, switchMap } from "@pjs/observables";
import { Immutable } from "@pjs/utilities";
import { getTemporaryAccessDetails } from "../functions/GetTemporaryAccessDetails.function";
import { emptyTemporaryAccessDetails } from "../consts/EmptyTempAccessDetails.const";
import { initialTemporaryAccessModel } from "../consts/InitialTempAccessModel.const";
import { ITemporaryAccessModel } from "../interfaces/ITemporaryAccessModel";

export class TemporaryAccessDetails {
    private _document: ModelDocument<ITemporaryAccessModel> = new ModelDocument(initialTemporaryAccessModel);

    public load(): Observable<Immutable<ITemporaryAccessModel>> {
        return getTemporaryAccessDetails().pipe(
            switchMap((details) => {
                this._document.model.details.update(details ?? emptyTemporaryAccessDetails);

                return this._document.model.pipe(startWith(this._document.model.get() as Immutable<ITemporaryAccessModel>));
            })
        );
    }

    public get(): ModelDocument<ITemporaryAccessModel> {
        return this._document;
    }

    public clear(): void {
        this._document.destroy();
        this._document = new ModelDocument(initialTemporaryAccessModel);
    }
}
